// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const PageLinkFragmentDoc = `
    fragment pageLink on Page {
  id
  path
}
    `;
export const PostLinkFragmentDoc = `
    fragment postLink on Post {
  id
  slug
}
    `;
export const CustomLinkFragmentDoc = `
    fragment customLink on LinkItemCustom {
  url
}
    `;
export const LinkQuestionnaireFragmentDoc = `
    fragment linkQuestionnaire on Questionnaire {
  id
}
    `;
export const LinkItemOpenEnquiryFormFragmentDoc = `
    fragment linkItemOpenEnquiryForm on LinkItemOpenEnquiryForm {
  enquiryType
}
    `;
export const LinkItemErRecommendationsFragmentDoc = `
    fragment linkItemErRecommendations on LinkItemEngagementRingRecommendations {
  __typename
  recommendations {
    designFeature {
      systemCode
    }
    designStyle {
      systemCode
    }
    metal {
      systemCode
    }
    ringStyle {
      systemCode
    }
    shape {
      systemCode
    }
  }
}
    `;
export const LinkItemFragmentDoc = `
    fragment linkItem on LinkItem {
  __typename
  ...pageLink
  ...postLink
  ...customLink
  ...linkQuestionnaire
  ...linkItemOpenEnquiryForm
  ...linkItemErRecommendations
}
    `;
export const LinkFragmentDoc = `
    fragment link on Link {
  text
  target
  item {
    ...linkItem
  }
}
    `;
export const LinkDesignStudioProductFragmentDoc = `
    fragment linkDesignStudioProduct on DesignStudioProduct {
  id
}
    `;
export const LinkOrderFragmentDoc = `
    fragment linkOrder on Order {
  id
}
    `;